export class DocumentSignersMissingError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, DocumentSignersMissingError.prototype);
  }
}
